import { createRef, ChangeEvent, useEffect } from "react";

import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { ICreateOperadora } from "src/Contexts/comissoes/ComissoesTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";

export const FormOperadora = () => {
  const { valuesInputsOperadora, setValuesInputsOperadora } =
    useContextComissoes();

  const refOrigem = createRef<HTMLInputElement>();
  const handleFocusedID = () => refOrigem.current?.focus();

  useEffect(() => {
    handleFocusedID();
  }, []);

  const handleChange =
    (prop: keyof ICreateOperadora) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesInputsOperadora((eventPrev) => ({
        ...eventPrev,
        [prop]: event.target.value,
      }));
    };

  return (
    <AppTextField
      fullWidth
      inputRef={refOrigem}
      label="Operadora *"
      sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
      value={valuesInputsOperadora?.name}
      variant="outlined"
      onChange={handleChange("name")}
    />
  );
};
